import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from './LanguageContext';
export function BookingCTA() {
  const {
    t
  } = useLanguage();
  return <section className="py-32 bg-studio-black relative overflow-hidden flex items-center justify-center" data-id="element-22">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-studio-gold/5 rounded-full blur-[100px] pointer-events-none" data-id="element-23"></div>

      <div className="max-w-4xl mx-auto px-4 text-center relative z-10" data-id="element-24">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-25">
          <h2 className="text-4xl md:text-6xl font-playfair text-white mb-8" data-id="element-26">
            {t('cta.title')}
          </h2>

          <a href="https://wa.me/17863086806" target="_blank" rel="noopener noreferrer" className="inline-block bg-studio-gold hover:bg-studio-gold-light text-studio-black font-inter font-semibold px-10 py-5 text-lg rounded-none tracking-widest uppercase transition-all duration-300 hover:shadow-[0_0_40px_rgba(201,168,76,0.4)] mb-8" data-id="element-27">
            {t('cta.bookBtn')}
          </a>

          <div className="flex flex-col items-center gap-2 text-gray-400 font-inter text-sm tracking-widest uppercase" data-id="element-28">
            <p data-id="element-29">{t('cta.address')}</p>
            <p className="text-studio-gold" data-id="element-30">{t('cta.appointmentOnly')}</p>
          </div>
        </motion.div>
      </div>
    </section>;
}